import { SuperFilterModule } from './super-filter/super-filter.module';
import { NvDropdownModule } from './../../../../nvps-libraries/design/nv-dropdown/nv-dropdown.module';
import { NetworkDashboardMadLibComponent } from './network-dashboard-mad-lib.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [NetworkDashboardMadLibComponent],
  imports: [CommonModule, NvDropdownModule, SuperFilterModule],
  exports: [NetworkDashboardMadLibComponent],
})
export class NetworkDashboardMadlibModule {
  //
}
